import { GridApi } from 'ag-grid-community'
import { ProjectPlanNewRow } from '../projectPlanNew'

export const buildUuidToRowIndexMap = (api: GridApi): Map<string, number> => {
  const map = new Map<string, number>()
  api.forEachNodeAfterFilterAndSort(node => {
    const uuid = (node.data as ProjectPlanNewRow | undefined)?.wbsItemUuid
    if (uuid && node.rowIndex != null) {
      map.set(uuid, node.rowIndex)
    }
  })
  return map
}
